<template>
  <card>
    <template slot="header">
      <h4 class="card-title">{{ $t("dashboard.export_title_inventory") }}</h4>
      <p class="card-category text-muted border-bottom pb-4">{{ $t("dashboard.export_subtitle_inventory") }}</p>
    </template>
    <div class="container py-3">
      <div class="row">
        <div class="col-12">
          <p class="card-category pb-4 mt-0 pt-0">{{ $t("dashboard.export_text_inventory") }}</p>
          <button class="btn btn-primary mb-2"  @click="exportAll">{{ $t("dashboard.export_inventory") }}</button>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import $http from "@/helpers/api";
export default {
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);

    return {
      exportData: [],
      date_from: "",
      date_to: "",
      max_date: maxDate,
      msg: ""
    };
  },
  console: () => console,
  mounted() {
    // $http.get("/export/repairs").then(resp => {
    //   this.exportData = {
    //     data: resp.data
    //   }
    //   // console.log(this.exportData.data);
    // });
    
  },
  methods: {
    getCurrentDate(){
      var myDate = new Date();
      var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      var day = ('0' + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      return year + '-' + month + '-' + day;
    },
    verifyDates(){
      if(this.date_from == "" || this.date_to == ""){
        this.notify(this.$t('dashboard.message.no_dates'));
        return false;
      }

      let date_from = new Date(this.date_from);
      let date_to = new Date(this.date_to);
      if(date_from.getTime() > date_to.getTime()){
        this.notify(this.$t('dashboard.message.end_date_greater'));
        return false;
      }

      let today = new Date(this.getCurrentDate());
      if(date_to.getTime() > today.getTime()){
        this.notify("End Date must not be greater than Today's Date");
        return false;
      }
      
      return true;
    },
    notify(msg){
      this.$notify({
        type: "danger",
        horizontalAlign: "center",
        message: msg
      });
    },
    exportAll(){
      let filename = 'CL-Inv_'+ this.getCurrentDate();
      this.export2Excel("/export/inventories/all", filename);
    },
    export2Excel(url, filename) {
      $http.get(url).then(resp => {
        this.exportData = {
          data: resp.data
        }

        let keys = Object.keys(this.exportData.data[0]);
        const tHeader = keys;
        const filterVal = keys;

        import('@/excel/Export2Excel').then(excel => {
          const list = this.exportData.data;  //Save tableData in data to list
          const data = this.formatJson(filterVal, list);
          
          excel.export_json_to_excel({
            header: tHeader, //Header Required
            data, //Specific data Required
            filename: filename, //Optional
            autoWidth: true, //Optional
            bookType: 'xlsx' //Optional
          })
        })
      });
      
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
};
</script>
